import { Select } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userReports } from '../../actions/reports/reports';

const AddToReportDropdown = ({ addReport, value, onChange }) => {
  const dispatch = useDispatch()
  const reportsResponse = useSelector(state => state.reports.userReports || {});
  const { data: { response: { reports = [] } = {} } = {} } = reportsResponse;

  const addUserReportsResponse = useSelector(
    (state) => state.reports.addUserReports || {}
  );
  useEffect(() => {
    dispatch(userReports({ status: 'unsubmitted' }));
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    if (addUserReportsResponse?.data?.status) {
      onChange && onChange(addUserReportsResponse?.data?.response?.report?.id);
      dispatch(userReports({ status: 'unsubmitted' }));
    }
    // eslint-disable-next-line
  }, [addUserReportsResponse])


  return (
    <Select
      className="w100"
      showSearch
      allowClear={true}
      value={value}
      placeholder="Select Report"
      filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())}
      options={reports?.length > 0 ? reports?.map(ele => ({
        label: (ele?.number ?? "") + " - " + ele.title,
        value: ele.id,
      })) : []}
      onChange={(val) => {
        onChange && onChange(val);
      }}
      dropdownRender={(menu) => {
        return <>
          {menu}
          <button className={'add-report'} onClick={addReport}>+ Add Report</button>
        </>
      }}
    />
  );
};

export default AddToReportDropdown;